import store from "App/Store.js";

export default loading => store.dispatch({type: "loading", loading});
